import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react'

/**
 * Legaturile care trebuie sa deschida fila noua.
 *
 * Randul desfasurat din lista de tichete e munca in lucru: cine apasa pe un
 * tichet inrudit, pe "+9 more" sau pe numele unui aparat nu trebuie sa piarda
 * tichetul deschis. Legatura pleaca in fila noua, lista ramane cum era.
 */
export const NEW_TAB = { target: '_blank', rel: 'noopener noreferrer' } as const

/** `<a>` care se deschide mereu in fila noua. */
export function NewTabLink(props: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  return <a {...props} {...NEW_TAB} />
}

/**
 * Plasa pentru panourile COMUNE care se deseneaza si in randul desfasurat -
 * fisa aparatului, sesiunile de remote, CMDB. Acolo legaturile raman cum sunt
 * (pe pagina aparatului se navigheaza pe loc, cum trebuie), iar inauntrul
 * randului desfasurat clicul simplu care ar fi schimbat pagina deschide fila
 * noua.
 *
 * Nu se atinge de:
 * - legaturile care isi opresc singure clicul (`preventDefault`) - filele,
 *   comutatoarele, "arata mai mult" de pe loc;
 * - `#...`, `javascript:`, `mailto:`, `tel:` si orice alta schema decat http(s)
 *   (`ssh://`, `rustdesk://`);
 * - descarcarile (`download`) si legaturile care au deja `target`;
 * - clicul cu Ctrl/Shift/Cmd/rotita - acolo alege browserul.
 */
export function NewTabScope({ children }: { children: ReactNode }) {
  return (
    <div className="od-new-tab-scope" style={{ display: 'contents' }} onClick={openInNewTab}>
      {children}
    </div>
  )
}

export function openInNewTab(ev: MouseEvent<HTMLElement>) {
  if (ev.defaultPrevented || ev.button !== 0 || ev.ctrlKey || ev.metaKey || ev.shiftKey || ev.altKey) return
  const a = (ev.target as Element | null)?.closest?.('a[href]')
  if (!(a instanceof HTMLAnchorElement)) return
  const raw = a.getAttribute('href') ?? ''
  if (raw === '' || raw.startsWith('#')) return
  if (a.hasAttribute('download') || (a.target !== '' && a.target !== '_self')) return
  let url: URL
  try {
    url = new URL(a.href, window.location.href)
  } catch {
    return
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return
  ev.preventDefault()
  window.open(url.href, '_blank', 'noopener,noreferrer')
}
